module.exports = __webpack_public_path__ + "img/blueRoundAdd.6384769f.svg";